import { api, PostActivityLogPayload } from '@/api';
import { useUser } from '@/core/user';
import { useReportStore } from '@/store';

export const useCreateActivityLog = () => {
  const { report } = useReportStore();
  const { user } = useUser();

  const postActivityLogMutation = api.fct.activityLogs.mutation.usePostActivityLogs();

  const createActivityLog = (payload: Partial<PostActivityLogPayload>, onSuccess?: () => void) => {
    if (!report) {
      return;
    }

    const postActivityLogPayload: PostActivityLogPayload = {
      action: 'CREATE',
      actor: user.user_id,
      fullObject: null,
      objectDiff: null,
      relatedObjectType: 'Report',
      relatedObjectUuid: report.uuid,
      reportUuid: report.uuid,
      studyId: report.studyId,
      ...payload,
    };

    postActivityLogMutation.mutate({ payload: postActivityLogPayload }, { onSuccess });
  };

  return createActivityLog;
};
